import { cn } from '@nexelem/utils';
import { cva, VariantProps } from 'class-variance-authority';
import { forwardRef } from 'react';

const styledDropAreaVariants = cva('h-full rounded-full border border-dashed border-icon-info', {
  variants: {
    isOver: {
      true: 'block',
      false: 'invisible border-0',
    },
    withAnimation: {
      true: 'transition-[width] duration-200 ease-in-out',
    },
  },
  defaultVariants: {
    isOver: false,
  },
});

type StyledDropAreaProps = {
  className?: string;
  width: number;
} & VariantProps<typeof styledDropAreaVariants>;

export const StyledDropArea = forwardRef<HTMLDivElement, StyledDropAreaProps>(
  ({ className, isOver, width, withAnimation, ...props }, ref) => (
    <div
      className={cn(styledDropAreaVariants({ isOver, withAnimation }), className)}
      ref={ref}
      style={{ width: isOver ? width : 0 }}
      {...props}
    />
  ),
);

StyledDropArea.displayName = 'StyledDropArea';
